<label
  [for]="upsell().id"
  data-cy="upsell-card"
  class="upsell-card relative flex flex-col items-center gap-2 p-3 pt-4 border-2 border-transparent rounded-3xl w-full h-full text-center cursor-pointer"
  [class.selected]="checked()"
  [class.disabled]="disabled()"
  [tooltip]="disabled() ? disabledTooltip() : ''"
  placement="top"
  triggers="mouseenter:mouseleave">
  <button
    type="button"
    class="top-3 right-3 z-10 absolute flex justify-center items-center w-3.5 h-3"
    [tooltip]="disabled() ? '' : upsell().description"
    placement="top"
    container="body"
    triggers="mouseenter:mouseleave focus:blur"
    [attr.aria-label]="disabled() ? null : upsell().description"
    [disabled]="disabled()"
    (click)="$event.preventDefault()">
    <img
      src="assets/img/info-circle-broken-icon.svg"
      class="w-full h-full"
      alt="" />
  </button>

  <img
    [ngSrc]="upsell().urlImage"
    class="w-[88px] h-[88px] object-cover"
    width="88"
    height="88"
    [priority]="false"
    alt="" />

  <div class="flex flex-col items-center gap-1">
    <h5 class="font-semibold text-[#404041] text-xs">{{ upsell().name }}</h5>
    <p class="font-extrabold text-black text-base">
      + ${{ upsell().price | number: '1.2-2' }}
    </p>
    <p class="font-semibold text-[#404041] text-xs">Per Ticket</p>
  </div>

  <div class="z-10 relative flex justify-center mt-auto pt-1">
    <input
      type="checkbox"
      class="sr-only"
      #radio
      [id]="upsell().id"
      [name]="upsell().id"
      [value]="upsell().buyerTypeId"
      [checked]="checked()"
      [disabled]="disabled()"
      (change)="onToggle(radio)" />
    <span class="toggle-track" [class.on]="checked()">
      <span class="toggle-thumb"></span>
    </span>
  </div>
</label>
